import { watch, type WatchStopHandle } from 'vue'

import { useCustomerStore } from '@stores/me/customer'

import { initClarity } from '@composables/tools/clarity.hook'

import { initAmplitude } from '@tools/amplitude'

const initAnalytics = (): void => {
  initAmplitude()
  initClarity()
}

export default defineNuxtRouteMiddleware(() => {
  const store = useCustomerStore()

  if (store.customer) {
    initAnalytics()
    return
  }

  let stop: WatchStopHandle | null = null

  stop = watch(
    () => store.customer,
    (customer) => {

      if (!customer) return

      try {
        initAnalytics()
      } finally {
        stop?.()
        stop = null
      }
    },
    {
      flush: 'post',
      immediate: false,
    },
  )
})
